import React from 'react';
import PropTypes from 'prop-types';

import { STAGES } from 'redux/modules/journeys/stop-status-log';

import StopStatusLogStage from './stage';

const StopStatusLog = React.memo(
  ({ actionSource, isLoading, variant, journeyId, stopId, className }) => {
    return (
      <div className={className}>
        {STAGES.map((stage) => (
          <StopStatusLogStage
            isLoading={isLoading}
            variant={variant}
            journeyId={journeyId}
            stopId={stopId}
            stage={stage}
            key={stage}
            actionSource={actionSource}
          />
        ))}
      </div>
    );
  }
);

StopStatusLog.propTypes = {
  journeyId: PropTypes.number.isRequired,
  stopId: PropTypes.number.isRequired,
  className: PropTypes.string,
  isLoading: PropTypes.bool,
  variant: PropTypes.string,
  actionSource: PropTypes.string,
};

StopStatusLog.defaultProps = {
  actionSource: 'UNKNOWN',
};

export default StopStatusLog;
